import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { Button } from 'components/Base';

interface RemoteSubmitButtonProps {
  dispatch: (val: any) => any;
  children: any;
  formName: string | string[];
  isLoading: boolean;
  className?: string;
  disabled?: boolean;
  id?: string;
  endIcon?: any;
  nonSubmitFunc?: Function;
  variant?: 'text' | 'outlined' | 'contained' | undefined;
  color?: 'inherit' | 'primary' | 'secondary' | 'default' | undefined;
  small?: boolean;
  callback?: Function | null;
}

const RemoteSubmit = ({
  dispatch,
  children,
  formName,
  disabled,
  id,
  nonSubmitFunc,
  variant = 'contained',
  color = 'secondary',
  small = false,
  callback = null,
  ...props
}: RemoteSubmitButtonProps) => {
  const submitForm = async (form: string) => {
    const success = await dispatch(submit(form));
    if (success && callback) {
      callback();
    }
  };

  return (
    <Button
      small={small}
      variant={variant}
      color={color}
      disabled={disabled}
      id={id}
      onClick={() => {
        if (nonSubmitFunc) nonSubmitFunc();
        [formName].flat().forEach(form => {
          submitForm(form);
        });
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default connect()(RemoteSubmit);
